var SwanPathTypeEnum;
(function (SwanPathTypeEnum) {
  SwanPathTypeEnum["hashed"] = "hashed";
  SwanPathTypeEnum["versioned"] = "versioned";
})(SwanPathTypeEnum || (SwanPathTypeEnum = {}));
var SwanAssetFolders;
(function (SwanAssetFolders) {
  SwanAssetFolders["FONTS"] = "FONTS";
  SwanAssetFolders["ICONS"] = "ICONS";
  SwanAssetFolders["IMAGES"] = "IMAGES";
  SwanAssetFolders["JS"] = "JS";
  SwanAssetFolders["STYLES"] = "STYLES";
  SwanAssetFolders["THEMES"] = "THEMES";
  SwanAssetFolders["FAVICONS"] = "FAVICONS";
  SwanAssetFolders["POLYFILLS"] = "POLYFILLS";
})(SwanAssetFolders || (SwanAssetFolders = {}));
var SwanFontScaleEnum;
(function (SwanFontScaleEnum) {
  SwanFontScaleEnum["LEGACY"] = "LEGACY";
  SwanFontScaleEnum["NEW"] = "NEW";
})(SwanFontScaleEnum || (SwanFontScaleEnum = {}));
export { SwanAssetFolders, SwanFontScaleEnum, SwanPathTypeEnum };